import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { Table } from "antd"

import { Value } from "@components/Text"
import { getCurrencyValue } from "@components/Amount"
import { getTransactionTypeLabel } from "@components/Transaction"
import { IndexBatchFilesOutputShape } from "@api/services/backstage"
import { IndexTransactionsOutputShape } from "@api/services/transactions"


const InvestmentAttachmentsTable = ({
  files,
  transactions,
  investmentId,
  getBatchName
}) => {
  const dataSource = useMemo(() =>
    [...files, ...transactions]
      .filter(item => investmentId === item.investmentId)
  , [ files, transactions, investmentId ])

  const columns = [
    {
      key: "id",
      title: "Attachment",
      dataIndex: "id",
      render: (id) => id.startsWith('FIL_') ? "Document" : "Transaction"
    },
    {
      key: "type",
      title: "Type",
      dataIndex: "type",
      render: (type, item) => item.documentType || getTransactionTypeLabel(type)
    },
    {
      key: "details",
      title: "Details",
      dataIndex: "details",
      render: (details, item) => item.batchId ? getBatchName(item.batchId) : getCurrencyValue(item.amount)
    },
    {
      key: "date",
      title: "Date",
      dataIndex: "date",
      render: value => <Value value={value} />,
    },
  ]

  const tableProps = {
    size: "small",
    rowKey: "id",
    pagination: false,
    columns,
    dataSource
  }

  return (
    <Table {...tableProps} />
  )
}

InvestmentAttachmentsTable.propTypes = {
  files: PropTypes.arrayOf(IndexBatchFilesOutputShape).isRequired,
  transactions: PropTypes.arrayOf(IndexTransactionsOutputShape).isRequired,
  investmentId: PropTypes.string.isRequired,
  getBatchName: PropTypes.func.isRequired,
}

export default InvestmentAttachmentsTable
